export const PicIcon = (
    <svg
        t="1713872268020"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4917"
        width="14"
        height="14"
    >
        <path
            d="M914 652.13h-47.35V504.26c0-20.81-16.87-37.68-37.68-37.68H557.41v-94.72h62.82c20.81 0 37.68-16.87 37.68-37.68V148.65c0-20.81-16.87-37.68-37.68-37.68H434.69c-20.81 0-37.68 16.87-37.68 37.68v185.54c0 20.81 16.87 37.68 37.68 37.68h47.37v94.72H210.5c-20.81 0-37.68 16.87-37.68 37.68v147.87H110c-20.81 0-37.68 16.87-37.68 37.68v185.54c0 20.81 16.87 37.68 37.68 37.68h185.54c20.81 0 37.68-16.87 37.68-37.68V689.81c0-20.81-16.87-37.68-37.68-37.68h-47.37V541.94h233.89v110.19h-62.82c-20.81 0-37.68 16.87-37.68 37.68v185.54c0 20.81 16.87 37.68 37.68 37.68h185.54c20.81 0 37.68-16.87 37.68-37.68V689.81c0-20.81-16.87-37.68-37.68-37.68h-47.37V541.94H791.3v110.19h-62.84c-20.81 0-37.68 16.87-37.68 37.68v185.54c0 20.81 16.87 37.68 37.68 37.68H914c20.81 0 37.68-16.87 37.68-37.68V689.81c0-20.81-16.87-37.68-37.68-37.68zM472.37 186.32h110.19v110.19H472.37V186.32z m-214.5 651.36h-110.2v-110.2h110.19v110.2z m309.24 0h-110.2v-110.2H567.1v110.2z m309.22 0h-110.2v-110.2h110.19v110.2z"
            fill="currentColor"
            p-id="4918"
        ></path>
    </svg>
);
export const GongshiIcon = (
    <svg
        t="1713872121151"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2393"
        width="14"
        height="14"
    >
        <path
            d="M414.896552 120.712109H169.777065c-29.151564 0-52.554932 23.403368-52.554932 52.554932V418.797113c0 29.151564 23.403368 52.554932 52.554932 52.554932h245.119487c29.151564 0 52.554932-23.403368 52.554932-52.554932V173.267041c0-28.740978-23.403368-52.554932-52.554932-52.554932z m-13.138733 197.080994H314.303128v87.454692H270.370489V317.793103H182.915798V274.271051h87.454691V186.405774H314.303128v87.454691h87.454691v43.932638z m451.23336-197.080994h-245.119487c-29.151564 0-52.554932 23.403368-52.554932 52.554932V418.797113c0 29.151564 23.403368 52.554932 52.554932 52.554932h245.119487c29.151564 0 52.554932-23.403368 52.554932-52.554932V173.267041c0-28.740978-23.403368-52.554932-52.554932-52.554932z m-13.138733 197.080994h-218.842021V274.271051H839.852446v43.522052zM414.896552 558.806736H169.777065c-29.151564 0-52.554932 23.403368-52.554932 52.554932v245.119487c0 29.151564 23.403368 52.554932 52.554932 52.554932h245.119487c29.151564 0 52.554932-23.403368 52.554932-52.554932v-245.119487c0-29.151564-23.403368-52.554932-52.554932-52.554932z m-29.562149 237.318364l-30.793906 30.793906-61.998396-61.998397-61.998396 61.998397-30.793905-30.793906 61.998396-61.998396L199.339214 672.128308l30.793905-30.793905 61.998397 61.998396 61.998396-61.998396 30.793905 30.793905-61.998396 61.998396 62.408982 61.998396z m467.656776-237.318364h-245.119487c-29.151564 0-52.554932 23.403368-52.554932 52.554932v245.119487c0 29.151564 23.403368 52.554932 52.554932 52.554932h245.119487c29.151564 0 52.554932-23.403368 52.554932-52.554932v-245.119487c0-29.151564-23.403368-52.554932-52.554932-52.554932z m-34.89976 241.013633H642.771451v-43.932638h175.319968v43.932638z m0-87.865277H642.771451v-43.932638h175.319968v43.932638z m0 0"
            fill="currentColor"
            p-id="2394"
        ></path>
    </svg>
);

export const CodeIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
    >
        <g fill="none">
            <path d="M0 0h24v24H0z"></path>
            <path
                fill="currentColor"
                d="M14.486 3.143a1 1 0 0 1 .692 1.233l-4.43 15.788a1 1 0 0 1-1.926-.54l4.43-15.788a1 1 0 0 1 1.234-.693M7.207 7.05a1 1 0 0 1 0 1.414L3.672 12l3.535 3.535a1 1 0 1 1-1.414 1.415L1.55 12.707a1 1 0 0 1 0-1.414L5.793 7.05a1 1 0 0 1 1.414 0m9.586 1.414a1 1 0 1 1 1.414-1.414l4.243 4.243a1 1 0 0 1 0 1.414l-4.243 4.243a1 1 0 0 1-1.414-1.415L20.328 12z"
            ></path>
        </g>
    </svg>
);

// 表
export const TableIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        version="1.1"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <clipPath id="master_svg0_18_18792">
                <rect x="0" y="0" width="16" height="16" rx="0" />
            </clipPath>
        </defs>
        <g clipPath="url(#master_svg0_18_18792)">
            <g>
                <path
                    d="M2,13C2,13.5523,2.447715,14,3,14L13,14C13.5523,14,14,13.5523,14,13L14,3C14,2.447715,13.5523,2,13,2L3,2C2.447715,2,2,2.447715,2,3L2,13ZM3,13L5.5,13L5.5,10L3,10L3,13ZM3,6.5L3,9L5.5,9L5.5,6.5L3,6.5ZM3,3L3,5.5L13,5.5L13,3L3,3ZM13,9L13,6.5L10.5,6.5L10.5,9L13,9ZM13,13L13,10L10.5,10L10.5,13L13,13ZM6.5,13L9.5,13L9.5,10L6.5,10L6.5,13ZM9.5,9L6.5,9L6.5,6.5L9.5,6.5L9.5,9Z"
                    fillRule="evenodd"
                    fill="currentColor"
                    fillOpacity="1"
                />
            </g>
        </g>
    </svg>
);

export const DataIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <line x1="22" x2="2" y1="12" y2="12" />
        <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.35 4H7.65a2 2 0 0 0-1.2.39z" />
        <line x1="6" x2="6.01" y1="16" y2="16" />
        <line x1="10" x2="10.01" y1="16" y2="16" />
    </svg>
);
